import { Navigate, useLocation } from 'react-router-dom'
import { ReactNode } from 'react'
import usePermissionsStore from '@/stores/usePermissionsStore'

type Props = {
    children: ReactNode
    fallbackPath?: string
}

/**
 * Route guard that redirects non-admin users to the fallback path.
 * Reads isAdmin from usePermissionsStore (populated on login/token verify).
 */
const RequireSuperAdmin = ({ children, fallbackPath = '/' }: Props) => {
    const { isAdmin } = usePermissionsStore()
    const location = useLocation()

    if (!isAdmin) {
        return <Navigate to={fallbackPath} state={{ from: location }} replace />
    }

    return <>{children}</>
}

export default RequireSuperAdmin
